import { Controller, useFormContext } from 'react-hook-form';
import {
  Box,
  FormHelperText,
  Stack,
  SxProps,
  TextareaAutosizeProps,
  Typography,
} from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';
import { ErrorHelperTextStyle } from '@/components/HookForm/RHFTextField';
import { TextareaAutosize } from './style';

export type RHFTextAreaProps = TextareaAutosizeProps & {
  readonly name: string;
  readonly sx?: SxProps;
} & Pick<TextFieldProps, 'helperText'>;

export default function RHFTextArea({
  name,
  helperText,
  maxLength,
  sx,
  ...otherProps
}: RHFTextAreaProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: otherProps.required }}
      render={({ field, fieldState: { error } }) => (
        <Stack>
          <TextareaAutosize
            {...field}
            {...otherProps}
            sx={{
              resize: 'none',
              ...otherProps,
            }}
            className={error ? 'error' : undefined}
            onChange={(e) => {
              field.onChange(e.target.value.slice(0, maxLength));
            }}
          />
          <Box sx={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
            {error && (
              <FormHelperText
                sx={{
                  ...ErrorHelperTextStyle,
                  justifyContent: 'initial',
                  flex: 1,
                  margin: 0,
                  padding: 0,
                }}
              >
                {error.message ?? ''}
              </FormHelperText>
            )}
            {maxLength !== undefined && (
              <Typography
                align={'right'}
                sx={{
                  fontSize: '14px',
                  marginLeft: 'auto',
                  flex: 'none',
                }}
              >
                {field.value?.length ?? 0}{' '}
                <Typography
                  component={'span'}
                  variant={'inherit'}
                  color={'var(--dk-text-disabled, #D4D7DB)'}
                >
                  / {maxLength}
                </Typography>
              </Typography>
            )}
          </Box>
        </Stack>
      )}
    />
  );
}
